/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationOr } from '../../models/organization-or';

export interface GetParentOrganizationDetails$Params {
  orid: number;
}

export function getParentOrganizationDetails(http: HttpClient, rootUrl: string, params: GetParentOrganizationDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OrganizationOr>>> {
  const rb = new RequestBuilder(rootUrl, getParentOrganizationDetails.PATH, 'get');
  if (params) {
    rb.path('orid', params.orid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OrganizationOr>>;
    })
  );
}

getParentOrganizationDetails.PATH = '/api/Organizations/parentstree/{orid}';
